import { type RefObject, useEffect } from 'react';

interface UseInertSiblingsProps {
    containerRef: RefObject<HTMLElement>;
    active: boolean;
}

export const useInertSiblings = ({ containerRef, active }: UseInertSiblingsProps) => {
    useEffect(() => {
        if (!active) return;
        if (typeof document === 'undefined') return;
        const containerEl = containerRef.current;
        if (!containerEl) return;

        const bodyChildren = Array.from(document.body.children) as HTMLElement[];
        const toToggle = bodyChildren.filter((el) => !el.contains(containerEl));

        toToggle.forEach((el) => {
            el.inert = true;
            el.setAttribute('aria-hidden', 'true');
        });

        return () => {
            toToggle.forEach((el) => {
                el.inert = false;
                el.removeAttribute('aria-hidden');
            });
        };
    }, [containerRef, active]);
};
